import type { ValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import type {
	ENTITY_NAME_FIELD_NAME,
	SHARE_PERMISSIONS_FIELD_NAME,
	EDIT_PERMISSIONS_FIELD_NAME,
	ENTITY_DESCRIPTION_FIELD_NAME,
} from '@atlassian/jira-shareable-entity-dialog/src/model/constants.tsx';
import {
	toServerValidationError,
	type ServerValidationErrors,
} from '@atlassian/jira-shareable-entity-dialog/src/model/types.tsx';

type ErrorFieldToFormFieldDictionary = {
	[key: string]:
		| typeof ENTITY_NAME_FIELD_NAME
		| typeof SHARE_PERMISSIONS_FIELD_NAME
		| typeof EDIT_PERMISSIONS_FIELD_NAME
		| typeof ENTITY_DESCRIPTION_FIELD_NAME;
};

export const createServerSideValidationErrorsGetter =
	(errorFieldToFormFieldDictionary: ErrorFieldToFormFieldDictionary) =>
	(validationError: ValidationError): ServerValidationErrors => {
		if (!validationError.errors) {
			// @ts-expect-error(PARTIAL_RECORD) TS2739 - Type '{}' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
			return {};
		}

		// @ts-expect-error(PARTIAL_RECORD) TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ServerValidationErrors': description, name, sharePermissions, editPermissions
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		return validationError.errors.reduce<Record<string, any>>((validationErrors, error) => {
			const formFieldName = errorFieldToFormFieldDictionary[error.field];
			if (formFieldName) {
				// Assigning is fine in .reduce() from a new object
				// eslint-disable-next-line no-param-reassign
				validationErrors[formFieldName] = toServerValidationError(error.error);
			}

			return validationErrors;
		}, {});
	};
